(() => {
  const countOf = (link) => {
    const badge = link.querySelector('.bnr-cart__count');
    return badge ? parseInt(badge.dataset.count, 10) || 0 : 0;
  };

  const timers = new WeakMap();

  const play = (el, ...classes) => {
    clearTimeout(timers.get(el));
    el.classList.remove(...classes);
    void el.offsetWidth;
    el.classList.add(...classes);
    const finish = () => el.classList.remove(...classes);
    el.addEventListener('animationend', function done(event) {
      if (event.target !== el || el.getAnimations().length) return;
      finish();
      el.removeEventListener('animationend', done);
    });
    // Reduced motion sets animation: none, so animationend may never fire.
    timers.set(el, setTimeout(finish, 3500));
  };

  const watch = (link) => {
    if (link.dataset.bnrCartWatched) return;
    link.dataset.bnrCartWatched = 'true';
    let last = countOf(link);

    new MutationObserver(() => {
      const next = countOf(link);
      if (next === last) return;
      const grew = next > last;
      last = next;

      const badge = link.querySelector('.bnr-cart__count');
      const icon = link.querySelector('.bnr-cart__icon-wrap');
      if (!grew) {
        link.classList.remove('is-confirming');
        if (badge) play(badge, 'is-popping');
        return;
      }
      if (badge) play(badge, 'is-popping', 'is-confirming');
      if (icon) play(icon, 'is-bouncing');
      play(link, 'is-confirming');
    }).observe(link, { childList: true, subtree: true });
  };

  const init = () => document.querySelectorAll('#cart-icon-bubble.bnr-cart').forEach(watch);

  init();
  document.addEventListener('shopify:section:load', init);
})();
